import { ValidationHelper } from '../../../../../helpers';
import { Layer } from '../layer';
// Abstract class for all overlay layers
export class OverlayLayer extends Layer {
    constructor(id, name, url, type, isVisible, opacity = 1, selectable = false, version = '1.1.1', center = false, format, subtitle, nameLegend, hidden, bbox) {
        super(id, name, url, type);
        // If layer can be centered
        this.center = false;
        this.subtitle = subtitle;
        this.nameLegend = nameLegend;
        this.isVisible = isVisible;
        this.selectable = selectable;
        this.format = format;
        this.version = version;
        this.opacity = opacity;
        this.hidden = hidden || false;
        this.center = center;
        this.bbox = bbox;
    }
    /**
     * Check if all mandatory properties exist
     * @returns A boolean value.
     */
    existProperties() {
        const existProperties = super.existProperties();
        return (existProperties
            && ValidationHelper.existProperty(this.isVisible));
    }
    /**
     * If the name property is a string, and the visible property is a boolean, and the selectable
     * property is a boolean, then return true.
     *
     * @returns The return value is a boolean.
     */
    sameTypeProperties() {
        const sameTypeProperties = super.sameTypeProperties();
        return (sameTypeProperties
            && ValidationHelper.sameTypeProperty(this.isVisible, 'boolean'));
    }
}
//# sourceMappingURL=overlayLayer.js.map